<div *ngIf="is_loading" class="p-3">Loading</div>
<div *ngIf="!is_loading" class="p-3">
    <pre [innerHTML]="str"></pre>
<input placeholder="Game ID" (input)="setGameID($event)"><br/>
<input placeholder="Total Bet" (input)="setTotalBet($event)"><br/>
<input placeholder="Total Bonus" (input)="setTotalBonus($event)"><br/>
<input placeholder="Game Brand" (input)="setGameBrand($event)"><br/>
<input placeholder="Game Name" (input)="setGameName($event)"><br/>
<input placeholder="Withdraw" (input)="setWithdrawal($event)"><br/>
<input placeholder="Minimum Bet" (input)="setMinBet($event)"><br/>
<input placeholder="Maximum Bet" (input)="setMaxBet($event)"><br/>

<hr/>
<div class="d-flex flex-row justify-content-between">
    <button class="btn btn-primary btn-lg" (click)="copy()">COPY</button>
    <button class="btn btn-danger btn-lg" (click)="close()">CLOSE</button>
</div>

</div>